import styled from "styled-components";
import "react-datepicker/dist/react-datepicker.css";

export const GraficoPocoStyled = styled.div`
  width: 100%;
  max-width: 100%;
  /* height: 210px; */
  height: 100%;
  border: 2px solid var(--cor-primaria);
  box-shadow: 2px 2px 10px var(--shadow);
  border-radius: 10px;
  display: flex;
  text-align: end;
  justify-content: end;
  position: relative;
  background-color: ${(props) => props.darkmode && "var(--conteiner-dark-eee)"};
  @media (min-width: 1600px) {
    /* width: 450px; */
  }

  .TitleContainer {
    position: absolute;
    top: 2px;
    right: 10px;
    width: 40px;
    height: 40px;
    .CiCalendar {
      font-size: 3rem;
      position: absolute;
      color: var(--cor-contraste);
      color: ${(props) =>
        props.darkmode ? "var(--fonte-dark-eee)" : "var(--cor-contraste)"};

      cursor: pointer;
      right: 0;
      top: -5px;
      z-index: 10;
    }
    .DateText {
      position: absolute;
      top: 14px;
      right: 14px;
      font-size: 20px;
      color: var(--cor-contraste);
      color: ${(props) =>
        props.darkmode ? "var(--fonte-dark-eee)" : "var(--cor-contraste)"};
    }
  }
  .CiCalendar:hover {
    color: var(--cor-hover);
  }
`;

export const CalendarioBombaStyled = styled.div`
  height: 200px;
  background-color: var(--branco);
  border-radius: 15px;
  width: 500px;
  max-width: 100%;
  height: 210px;
  border: 2px solid var(--cor-contraste);
  padding-top: 12px;
  display: flex;
  text-align: end;
  justify-content: end;
  position: relative;

  .TitleContainer {
    position: absolute;
    top: 2px;
    right: 0px;
    width: 40px;
    height: 40px;
    .CiCalendar {
      font-size: 3rem;
      position: absolute;
      color: var(--cor-contraste);
      cursor: pointer;
      right: 0;
      top: -5px;
      z-index: 10;
    }
    .DateText {
      position: absolute;
      top: 14px;
      right: 14px;
      font-size: 20px;
      color: var(--cor-contraste);
    }
  }
  .CiCalendar:hover {
    color: var(--cor-primaria);
  }
`;

export const ModalCalenderPoco = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100dvh;
  z-index: 1000;

  h2 {
    color: var(--cor-contraste);
  }
  .conteiner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 25px;
    width: 40%;
    height: 80dvh;
    border-radius: 10px;
    background: var(--cinza);
    border: 2px solid var(--cor-primaria);
    position: relative;
    @media (max-width: 1160px) {
      width: 60%;
    }
    @media (max-width: 660px) {
      width: 90%;
    }
    .botaoFechaAgenda {
      position: absolute;
      top: -8px;
      right: -10px;
      font-size: 18px;
      background: var(--branco);
      border-radius: 3px;
      width: 30px;
      height: 30px;
      max-width: 100%;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
      border-radius: 50%;
      transition: 0.3s;
    }
    .botaoFechaAgenda:hover {
      background-color: var(--cor-primaria);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);

      box-shadow: 2px 2px 10px var(--shadow);
    }
    .selectRelatorio {
      label {
        font-weight: 600;
        font-size: 18px;
      }
      select {
        border: 2pxx solid var(--cor-primaria);
        padding: 5px;
        border-radius: 5px;
      }
    }
    .buttonsRelatorio {
      display: flex;
      width: 100%;
      justify-content: center;
      align-items: end;
      gap: 20px;

      height: 50px;
      button {
        padding: 10px 20px;
        background: var(--branco);
        transition: 0.5s;
        font-weight: bold;
        border: 3px solid var(--cor-primaria);
        border-radius: 5px;
        color: var(--cor-primaria);
        cursor: pointer;
      }
      button:hover {
        background: var(--cor-primaria);
        color: var(--branco);
        border: 3px solid var(--cor-primaria);
        box-shadow: 2px 2px 10px var(--shadow);
        transition: 0.5s;
      }
    }
  }
`;

export const ModalCalenderBomba = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  background-color: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100vh;
  z-index: 1000;

  h2 {
    color: var(--cor-contraste);
  }
  .conteiner {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 25px;
    width: 350px;
    height: 600px;
    border-radius: 10px;
    background: var(--cinza);
    border: 3px solid var(--cor-primaria);
    .botaoFechaAgenda {
      font-size: 18px;
      background: var(--branco);
      border-radius: 3px;
      width: 70%;
      height: 40px;
      max-width: 100%;
      cursor: pointer;
      color: var(--cor-primaria);
      font-weight: bold;
      border: 2px solid var(--cor-primaria);
      margin-top: 50px;
      transition: 0.3s;
    }
    .botaoFechaAgenda:hover {
      background-color: var(--cor-primaria);
      color: var(--branco);
      border: 2px solid var(--cor-primaria);

      box-shadow: 2px 2px 10px var(--shadow);
    }
  }
`;
